import { api } from ".."

export const getCategories = (size: number, offset: number) => {
  return api.get('/categories', { params: { size, offset } });
}